import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Flag proxy ESS sessions BEFORE React mounts so every auth state read
// uses sessionStorage (isolated from the admin's localStorage).
if (
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/ess-proxy")
) {
  sessionStorage.setItem("essProxySession", "true");
}
import { AttendanceCodeConfigProvider } from "./context/attendanceCodeConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AttendanceCodeConfigProvider>
    <App />
  </AttendanceCodeConfigProvider>
);
